module.exports = __webpack_public_path__ + "fransa mutfak 9.jpg?6f102f727e40c8063e8adbe679489cfc";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 9.jpg
// module id = 331
// module chunks = 0